import { Box } from '@mui/material'
import { FC } from 'react'
import { Button } from 'utoniq-ui'

import { useTranslation } from '@/core'

export const SkipButton: FC<{
  onSkip: () => void
}> = ({ onSkip }) => {
  const { t } = useTranslation('gachaDetail')

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundColor: 'transparent',
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 13,
        pointerEvents: 'none',
        maxWidth: '600px',
        px: 4,
        py: 4,
        display: 'grid',
        placeContent: 'end',
        alignItems: 'end',
      }}
    >
      <Button
        onClick={onSkip}
        variant="text"
        sx={{
          pointerEvents: 'auto',
          color: 'text.hint',
        }}
      >
        {t('skip', 'スキップ')}
      </Button>
    </Box>
  )
}
